import DataRetriever from "app/data_retriever"

// The following are just something to fallback to in case of worst scenario.
// Hardcoded Hong Kong.
const DEFAULT_COORDINATES   = [22.294020222179054, 114.16477203369142] as [number, number]
const DEFAULT_ZOOM_LEVEL    = 11
const DEFAULT_COUNTRY_CODE  = "HK"


const getDefaultCoordinate = (): [number, number] => {
  const latitude = parseFloat(DataRetriever.get("city-default-latitude"))
  const longitude = parseFloat(DataRetriever.get("city-default-longitude"))

  if ([latitude, longitude].some(isNaN)){
    return DEFAULT_COORDINATES
  }

  return [latitude, longitude]
}

const getDefaultZoom  = () => {
  const result = parseInt(DataRetriever.get("city-default-zoom-level"), 10)

  if (isNaN(result)) { return DEFAULT_ZOOM_LEVEL }

  return result
}

const getDefaultCountryCode = () => {
  const result = DataRetriever.get("city-default-country-code")
  if (typeof result !== "string") { return DEFAULT_COUNTRY_CODE }
  return result
}

export default {
  getDefaultCoordinate,
  getDefaultZoom,
  getDefaultCountryCode,
}
